import { render, staticRenderFns } from "./Subscribers.vue?vue&type=template&id=566ab11e&scoped=true"
import script from "./Subscribers.vue?vue&type=script&lang=js"
export * from "./Subscribers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566ab11e",
  null
  
)

export default component.exports